"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _constants = require("../constants");
var _enums = _interopRequireDefault(require("./enums"));
var canUserStart = function canUserStart(displayHints) {
  return displayHints.includes(_constants.DISPLAY_HINTS.RECORDING_CONTROL_START);
};
var canUserPause = function canUserPause(displayHints) {
  return displayHints.includes(_constants.DISPLAY_HINTS.RECORDING_CONTROL_PAUSE);
};
var canUserResume = function canUserResume(displayHints) {
  return displayHints.includes(_constants.DISPLAY_HINTS.RECORDING_CONTROL_RESUME);
};
var canUserStop = function canUserStop(displayHints) {
  return displayHints.includes(_constants.DISPLAY_HINTS.RECORDING_CONTROL_STOP);
};
var extractLocusId = function extractLocusId(url) {
  return url === null || url === void 0 ? void 0 : url.split('/').pop();
};
var deriveRecordingStates = function deriveRecordingStates(action) {
  var recording;
  var paused;
  switch (action) {
    case _enums.default.Start:
      recording = true;
      paused = false;
      break;
    case _enums.default.Stop:
      recording = false;
      paused = false;
      break;
    case _enums.default.Resume:
      recording = true;
      paused = false;
      break;
    case _enums.default.Pause:
      recording = true;
      paused = true;
      break;
    default:
      throw new Error("Recording state cannot be derived from invalid action: ".concat(action));
  }
  return {
    recording: recording,
    paused: paused
  };
};
var _default = {
  canUserStart: canUserStart,
  canUserPause: canUserPause,
  canUserResume: canUserResume,
  canUserStop: canUserStop,
  deriveRecordingStates: deriveRecordingStates,
  extractLocusId: extractLocusId
};
exports.default = _default;
//# sourceMappingURL=util.js.map
